export const trans = import.meta.glob<true, string, Dict>(
  '/src/modules/locales/res/**/notFound.json',
  {
    eager: true,
  },
);
